import * as createjs from 'createjs-module';
import { AppGlobals } from '../../shared/app.global';
import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/map';
// import * as $ from 'jquery';
import 'rxjs/add/operator/catch';
declare var $: any;


@Injectable()
export class SpriteControllerComponent {
  private spriteObj: object = null;
  private spriteObjKey: any = null;
  public nextClicked: any = false;

  constructor(public appGlobal: AppGlobals, public http: Http) {
    // this.loadJson();
    // this.appGlobal.nextBtnClk.subscribe(() => {
    //   this.nextClicked = true;
    // });
  }
   loadJson(): void {
    var self = this;

  }

  createObject(index, spriteKey, jsonObj) {



  }
  playSprite(spriteKey): void {
    this.spriteObj[spriteKey].spriteName.gotoAndPlay(0)
  }
  pauseSprite(spriteKey): void {
    this.spriteObj[spriteKey].spriteName.paused = true;
  }
  stopSprite(spriteKey): void {
    this.spriteObj[spriteKey].spriteName.stop()
  }
  stopAllSprite(): void {
    var self = this;
    for (let i in this.spriteObj) {
      self.spriteObj[i].spriteName.stop();
    }
  }
  public getJSON(path): Observable<any> {
    return this.http.get(path)
      .map((res: any) => res.json())
      .catch((error: any): any => console.log(error));

  } 
}